"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setCanaryHeader_1 = require("./setCanaryHeader");
var ATTEMPT_HEADER = 'X-OWA-Attempt';
function addFetchRetryHeaders(attemptCount, headers) {
    setCanaryHeader_1.default(headers);
    headers.set(ATTEMPT_HEADER, '' + attemptCount);
}
exports.default = addFetchRetryHeaders;
